import React from "react";
import TimeAgoPlugin from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";

export interface TimeAgoProps {
  time: Date;
}

const TimeAgo = ({ time }: TimeAgoProps) => {
  TimeAgoPlugin.addLocale(en);
  const timeAgo = new TimeAgoPlugin("en-US");

  return <>{timeAgo.format(time)}</>;
};

export default TimeAgo;
